import { useContext, useEffect } from "react"

import Userback from "@userback/widget"
import styled from "styled-components"

import Footer from "components/Footer"
import Header from "components/Header"
import HeaderBurger from "components/HeaderBurger"
import colors from "styles/colors"
import media from "styles/media"
import { useBackButton } from "utils/Loader/TransitionUtils"
import { useTrackPageReady } from "utils/pageReady"

import PopUp from "./Banners/PopUp"
import ThinBanner from "./Banners/ThinBanner"
import VideoModal from "./Banners/VideoModal"
import { ShowHamburger, TestimonialsContext } from "./Providers"

interface Props {
  id: string
  children: React.ReactNode | React.ReactNode[]
  waveBottomColor?: string
  hideFooter?: boolean
  hideHeader?: boolean
  hideOverflow?: boolean
  pathname: string
  languageOverride?: string
}

export default function Layout({
  children,
  id,
  waveBottomColor = colors.blue700,
  hideFooter = false,
  hideHeader = false,
  hideOverflow = false,
  pathname,
  languageOverride,
}: Props) {
  const { activeTestimonialPage, activeVideo } = useContext(TestimonialsContext)
  const { setShow } = useContext(ShowHamburger)

  useBackButton()
  useTrackPageReady()

  useEffect(() => {
    Userback("37568|73347|v0IzZWe1Wp6WdUZsgSwl1T41O").catch(e => {
      console.error(e)
    })
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <ThinBanner />
      <PopUp />
      {activeTestimonialPage && (
        <VideoModal setShow={setShow} open={!!activeVideo}>
          <VideoIframe
            allow="fullscreen;"
            title="Generic title"
            src={`https://www.youtube.com/embed/${activeVideo ?? ""}`}
            width="100%"
            height="auto"
          />
        </VideoModal>
      )}
      <HeaderBurger pathname={pathname} languageOverride={languageOverride} />
      {!hideHeader && <Header languageOverride={languageOverride} />}
      {/* <SEO pageAttributes={pageAttributes} /> */}
      <Main hideOverflow={hideOverflow} id={id}>
        {children}
        {!hideFooter && (
          <Footer
            waveBottomColor={waveBottomColor}
            pathname={pathname}
            languageOverride={languageOverride}
          />
        )}
      </Main>
    </>
  )
}

// this code would highlight all images that are not gatsby images
/* *:not(.gatsby-image-wrapper) > img {
    background: orange !important;
    object-position: 99999px 99999px !important;
  }
  .gatsby-image-wrapper img {
    background: none !important;
    object-position: unset !important;
  }
  img[src*="data:image/svg+xml"] {
    background: none !important;
    object-position: unset !important;
  }
  img[src*=".svg"] {
    background: none !important;
    object-position: unset !important;
  } */

const VideoIframe = styled.iframe`
  position: relative;
  aspect-ratio: 16/9;

  outline: none;
  border: none;
  overflow: hidden;

  ${media.fullWidth} {
    margin: 100px 0;
    border-radius: 20px;
  }
  ${media.desktop} {
    margin: 6.024vw 0;
    border-radius: 1.205vw;
  }
  ${media.tablet} {
    margin: 9.766vw 0;
    border-radius: 1.953vw;
  }
  ${media.mobile} {
    margin: 13.333vw 0;
    border-radius: 2.667vw;
  }
`

const Main = styled.main<{ hideOverflow: boolean }>`
  width: 100%;
  background: ${colors.lightMode};
  overflow: ${({ hideOverflow: overflow }) => (overflow ? "hidden" : "unset")};
`
